import {
    TransactionEntryCategoryFieldsFragment,
    TransactionEntryCategoryGroupFieldsFragment,
} from '../../graphql/generated';
import { dt } from '../../util/dateTime';
import { AMOUNT_BY_MONTH_FORMAT, CashflowTransactionEntry } from '../cashflow';

type CategoryGroupSum = {
    id: string;
    amount: number;
    amountByMonth: { [key: string]: number };
    categoryGroup: TransactionEntryCategoryGroupFieldsFragment;
};

type CategorySum = {
    id: string;
    amount: number;
    amountByMonth: { [key: string]: number };
    category: TransactionEntryCategoryFieldsFragment;
};

export const sumCategories = ({
    transactionEntries,
}: {
    transactionEntries: CashflowTransactionEntry[];
}) => {
    const categoryGroupSums: Record<string, CategoryGroupSum> = {};
    const categorySums: Record<string, CategorySum> = {};

    const accumulateAmount = <
        T extends { amount: number; amountByMonth: Record<string, number> },
    >(
        sums: Record<string, T>,
        id: string,
        amount: number,
        month: string,
        initialRecord: T
    ) => {
        if (!sums[id]) {
            sums[id] = initialRecord;
        }

        if (!sums[id].amountByMonth[month]) {
            sums[id].amountByMonth[month] = 0;
        }

        sums[id].amount += amount;
        sums[id].amountByMonth[month] += amount;
    };

    for (const transactionEntry of transactionEntries) {
        const month = dt(transactionEntry.date).format(AMOUNT_BY_MONTH_FORMAT);

        accumulateAmount(
            categoryGroupSums,
            transactionEntry.category.categoryGroup.id,
            transactionEntry.amount,
            month,
            {
                id: transactionEntry.category.categoryGroup.id,
                amount: 0,
                amountByMonth: {},
                categoryGroup: transactionEntry.category.categoryGroup,
            }
        );

        accumulateAmount(
            categorySums,
            transactionEntry.category.id,
            transactionEntry.amount,
            month,
            {
                id: transactionEntry.category.id,
                amount: 0,
                amountByMonth: {},
                category: transactionEntry.category,
            }
        );
    }

    return {
        categoryGroupSums: Object.values(categoryGroupSums),
        categorySums: Object.values(categorySums),
    };
};
